export const paymentTiers = [
  "Unlock CV Review",
  "Unlock + CV Rewrite",
  "Ready to Use CV in 3 Different Format",
  "Interview Session",
  "Career OS",
  "Career OS - Ideal Job Fit",
  "Career OS - CV Personalization",
  "Career OS - LinkedIn Optimization",
  "CV Enhancement with AI",
] as const;

export type PaymentTier = (typeof paymentTiers)[number];

export const paymentTierPriority: Record<PaymentTier, number> = {
  "Unlock CV Review": 1,
  "Unlock + CV Rewrite": 2,
  "Ready to Use CV in 3 Different Format": 3,
  "Interview Session": 0,
  "Career OS": 0,
  "Career OS - Ideal Job Fit": 0,
  "Career OS - CV Personalization": 0,
  "Career OS - LinkedIn Optimization": 0,
  "CV Enhancement with AI": 0,
};

export const paymentTierAmount: Record<PaymentTier, number> = {
  "Unlock CV Review": 30000,
  "Unlock + CV Rewrite": 40000,
  "Ready to Use CV in 3 Different Format": 50000,
  "Interview Session": 50000,
  "Career OS": 79000,
  "Career OS - Ideal Job Fit": 50000,
  "Career OS - CV Personalization": 50000,
  "Career OS - LinkedIn Optimization": 50000,
  "CV Enhancement with AI": 25000,
};

/**
 * `unlock-rewrite` is retired from the checkout picker (the CV review ladder is
 * Unlock / Unlock + 3 formats / Career Booster). It stays mapped here so
 * historical payments, issued vouchers, and finalize-payment keep resolving.
 */
export const paymentTierById = {
  "unlock-review": "Unlock CV Review",
  "unlock-rewrite": "Unlock + CV Rewrite",
  "ready-to-use": "Ready to Use CV in 3 Different Format",
  "career-os": "Career OS",
} as const satisfies Record<string, PaymentTier>;

export type PaymentTierId = keyof typeof paymentTierById;

export function isPaymentTierId(
  value: string | null | undefined,
): value is PaymentTierId {
  return typeof value === "string" && value in paymentTierById;
}

/**
 * Canonical `product` value reported on the `payment_success` analytics event,
 * keyed off the DB-authoritative tier so every payment flow reports the same
 * slug for the same tier. Client code previously invented ad hoc product
 * strings per call site (`career_booster`, `career_bundle`, `career_os_bundle`
 * all meant "Career OS"); this is the single source of truth going forward.
 */
export const paymentTierProduct: Record<PaymentTier, string> = {
  "Unlock CV Review": "cv_review",
  "Unlock + CV Rewrite": "cv_review",
  "Ready to Use CV in 3 Different Format": "cv_review",
  "Interview Session": "interview_session",
  "Career OS": "career_os_bundle",
  "Career OS - Ideal Job Fit": "career_os_ideal_job_fit",
  "Career OS - CV Personalization": "career_os_cv_personalization",
  "Career OS - LinkedIn Optimization": "career_os_linkedin_optimization",
  "CV Enhancement with AI": "cv_enhancement_ai",
};

export function getPaymentProduct(tier: PaymentTier): string {
  return paymentTierProduct[tier];
}
